var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorFieldIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9.5,
    r: 9,
    fill: "#EC4652"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9 15c.4 0 .8-.3.8-.7 0-.5-.4-.8-.8-.8s-.7.3-.7.7c0 .4.3.8.7.8zM8 4.5h1.8l-.3 7.8H8.3L8 4.5z",
    fill: "#fff"
  })));
}
export default SvgErrorFieldIcon;